/* eslint-disable no-unused-expressions */
import {Power0, Power1} from 'gsap';

let svgScheme = '.chapter-position .chapter-fixed__figure.scheme-1 svg';
let scheme = document.querySelector(svgScheme);
let fullAnimation = null;

const setStrokeDashoffset = (el) => {
	const path = el.getTotalLength();
	gsap.set(el, {
		strokeDashoffset: path,
		strokeDasharray: `${path}, ${path}`,
	});
};

const play = () => {
	if (fullAnimation && fullAnimation.paused()) {
		fullAnimation.play();
	}
};

const pause = () => {
	if (fullAnimation && !fullAnimation.paused()) {
		fullAnimation.pause();
	}
};

const reset = () => {
	const tm = gsap.timeline();
	const lines = scheme.querySelectorAll('.lines-group .lines');
	const spindle = scheme.querySelector('.spindle-1');
	const spindleSecond = scheme.querySelector('.spindle-2');
	const sensor = scheme.querySelectorAll('.sensors');
	const graphOpacity = scheme.querySelector('.graph-opacity');

	const graphBorder = scheme.querySelector('.graph-border');

	const graphCircle = scheme.querySelector('.graph-circle');
	const paths = graphCircle.querySelectorAll('.graph-circle-fiil path');
	const graphCircleBorderStroke = graphCircle.querySelector('.graph-circle-border-stroke');

	// vibration-sensor
	const parent = scheme.querySelector('.vibration-sensor');
	const line = parent.querySelector('.vibration-sensor-circle');
	const lineFill = parent.querySelector('.vibration-sensor-circle-fill');
	const vibrationSensor = parent.querySelector('.vibration-sensor-figure');
	const vibrationSensorCircle = parent.querySelector('.vibration-sensor-figure-circle');

	// graph-3
	const graphLineFirst = scheme.querySelectorAll('.graph-1, .graph-2');

	// graph-3
	const graphLine = scheme.querySelectorAll('.graph-3, .graph-4');

	sensor.forEach((element) => {
		const highlight = element.querySelector('.sensors-highlight');
		const circles = element.querySelectorAll('.sensors-circle');
		const projector = element.querySelectorAll('.sensors-projector-color');

		tm
			.set([circles, projector], {
				autoAlpha: 0,
			})
			.set(highlight, {
				autoAlpha: 0,
			});
	});

	tm
		.set([graphOpacity, lineFill, paths], {
			autoAlpha: 0,
		})
		.set(vibrationSensor, {
			scaleX: 0,
			scaleY: 0,
			x: 100,
			y: 100,
		})
		.set(graphBorder, {
			fill: '#96D1FF',
		})
		.set(spindle, {
			x: 0,
			y: 107,
		})
		.set(spindleSecond, {
			x: -38,
			y: -18,
		});

	lines.forEach((element) => {
		const defaultLine = element.querySelector('.lines-default');
		const gradientLine = element.querySelector('.lines-gradient');
		const gradientLineOpacity = element.querySelector('.lines-gradient-opacity');

		if (defaultLine) {
			setStrokeDashoffset(defaultLine);
		}

		if (gradientLine) {
			setStrokeDashoffset(gradientLine);

			tm
				.set(gradientLine, {
					autoAlpha: 0,
				});
		}

		tm
			.set(gradientLineOpacity, {
				autoAlpha: 0,
			});
	});
	graphLineFirst.forEach((element) => {
		const elhLine = element.querySelector('.graph-default');
		const elhLineFill = element.querySelector('.graph-gradient');
		const elbg = element.querySelector('.graph-fill');

		if (elhLine) {
			setStrokeDashoffset(elhLine);
		}

		if (elhLineFill) {
			setStrokeDashoffset(elhLineFill);

			tm
				.set(elhLineFill, {
					autoAlpha: 0,
				});
		}

		tm
			.set(elbg, {
				autoAlpha: 0,
			});
	});

	graphLine.forEach((element) => {
		const elhLine = element.querySelector('.graph--line');
		const elhLineFill = element.querySelector('.graph--line-fill');

		if (elhLine) {
			setStrokeDashoffset(elhLine);
		}

		if (elhLineFill) {
			setStrokeDashoffset(elhLineFill);

			tm
				.set(elhLineFill, {
					autoAlpha: 0,
				});
		}
	});
	setStrokeDashoffset(graphCircleBorderStroke);
	setStrokeDashoffset(lineFill);
	setStrokeDashoffset(line);
	setStrokeDashoffset(vibrationSensorCircle);
};

const lighting = () => {
	const sensor = scheme.querySelectorAll('.sensors');
	sensor.forEach((element, i) => {
		const tm = gsap.timeline({repeat: -1,
			yoyo: true});
		const projectorTm = gsap.timeline();
		fullAnimation
			.add(tm.play(), 0)
			.add(projectorTm.play(), 0);
		const highlight = element.querySelector('.sensors-highlight');
		const circles = element.querySelectorAll('.sensors-circle');
		const cnt = `${i * 0.3}`;
		const projector = element.querySelector('.sensors-projector-color');

		projectorTm
			.to(projector, 0.5, {
				autoAlpha: 1,
			}, cnt)
			.to(highlight, 1, {
				ease: Power0.easeInOut,
				autoAlpha: 1,
			}, cnt);
		tm
			.to(circles, 0.35, {
				ease: Power0.easeInOut,
				autoAlpha: 1,
				stagger: 0.15,
			}, cnt + 0.5);
	});
};

const graphOpacityAnimate = () => {
	const tm = gsap.timeline({repeat: -1,
		yoyo: true});
	fullAnimation.add(tm.play(), 0);
	const graphOpacity = scheme.querySelector('.graph-opacity');

	tm.to(graphOpacity, 2, {
		ease: Power1.easeInOut,
		autoAlpha: 1,
	});
};

const spindle = ({el, time = 1.5, repeat = false}) => {
	const option = {
		repeat: -1,
		yoyo: true,
	};
	const tm = gsap.timeline(repeat && option);

	fullAnimation
		.add(tm.play(), 0);

	tm.to(el, time, {
		ease: Power0.easeInOut,
		x: 0,
		y: 0,
	});
};

const graphLineAnimate = () => {
	const graphLine = scheme.querySelectorAll('.graph-3, .graph-4');

	graphLine.forEach((element, i) => {
		const elhLine = element.querySelector('.graph--line');
		const elhLineFill = element.querySelector('.graph--line-fill');
		const time = 3;
		const tm = gsap.timeline({
			repeat: -1,
			yoyo: true,
		});

		fullAnimation.add(tm.play(), i * 2);

		tm.to([elhLine, elhLineFill], {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
			stagger: 0,
		}, 0);

		if (elhLineFill) {
			tm.to(elhLineFill, {
				autoAlpha: 1,
				duration: time,
				stagger: 0,
			}, 0);
		}
	});
};

const graphLineFirstAnimate = () => {
	const graphLine = scheme.querySelectorAll('.graph-1, .graph-2');

	graphLine.forEach((element, i) => {
		const tm = gsap.timeline({repeat: -1,
			yoyo: true});
		fullAnimation.add(tm.play(), i);
		const elhLine = element.querySelector('.graph-default');
		const elhLineFill = element.querySelector('.graph-gradient');
		const elbg = element.querySelector('.graph-fill');
		const time = 3;
		tm
			.to([elhLine, elhLineFill], {
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
				duration: time,
				stagger: 0,
			}, 0)
			.to(elhLineFill, {
				autoAlpha: 1,
				duration: time,
				stagger: 0,

			}, 0)
			.to(elbg, {
				autoAlpha: 1,
				duration: time / 2,
				stagger: 0,

			}, time / 2);
	});
};

const graphCircleAnimetion = () => {
	const graphCircle = scheme.querySelector('.graph-circle');

	const tm = gsap.timeline({repeat: -1,
		yoyo: true});
	fullAnimation.add(tm.play(), 2.5);

	const paths = graphCircle.querySelectorAll('.graph-circle-fiil path');
	const elhLineFill = graphCircle.querySelector('.graph-circle-border-stroke');
	// const elbg = element.querySelector('.graph-fill');
	tm
		.to(paths, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: 0.25,
			stagger: 0.05,
			autoAlpha: 1,
		}, 0)
		.to(elhLineFill, {
			duration: 3.5,
			strokeDashoffset: 0,
			stagger: 0,

		}, 0);
};

const vibrationSensorAnimate = () => {
	const tm = gsap.timeline();
	const parent = scheme.querySelector('.vibration-sensor');
	const line = parent.querySelector('.vibration-sensor-circle');
	const lineFill = parent.querySelector('.vibration-sensor-circle-fill');
	const vibrationSensor = parent.querySelector('.vibration-sensor-figure');
	const vibrationSensorCircle = parent.querySelector('.vibration-sensor-figure-circle');

	const time = 0.75;

	fullAnimation
		.add(tm.play(), 0);

	tm.to(line, {
		ease: Power0.easeInOut,
		strokeDashoffset: 0,
		duration: time,
	});

	tm
		.to(lineFill, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		}, 0)
		.to(vibrationSensor, {
			scaleX: 1,
			scaleY: 1,
			x: 0,
			y: 0,
			duration: time,
		}, 0)
		.to(vibrationSensorCircle, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		}, 0)
		.to(lineFill, {
			autoAlpha: 1,
			duration: 0.5,
		}, time * 0.3);
};

const startAnimeProgressLine = () => {
	const lines = scheme.querySelectorAll('.lines-group .lines');
	// const length = lines.length - 1;

	lines.forEach((element) => {
		const tm = gsap.timeline();
		fullAnimation.add(tm.play(), 0);
		const defaultLine = element.querySelector('.lines-default');
		const gradientLine = element.querySelector('.lines-gradient');
		const gradientLineOpacity = element.querySelector('.lines-gradient-opacity');
		const time = 4.5;

		tm
			.to([defaultLine, gradientLine], {
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
				duration: time,
				stagger: 0,
			}, 0)
			.to(gradientLine, {
				autoAlpha: 1,
				duration: time,
				delay: 1.5,
				stagger: 0,
			}, 0)
			.to(gradientLineOpacity, {
				autoAlpha: 1,
				duration: 1,
				delay: time,
				stagger: 0,
			}, 0);
	});
};

const graphBorderAnimate = () => {
	const tm = gsap.timeline();
	const graphBorder = scheme.querySelector('.graph-border');

	fullAnimation.add(tm.play(), 0);
	tm
		.to(graphBorder, {
			ease: Power0.easeInOut,
			fill: '#E0A672',
			duration: 1,
		}, 0);
};

const create = () => {
	fullAnimation = gsap.timeline({paused: true});

	spindle({
		el: scheme.querySelector('.spindle-1'),
		repeat: true,
		time: 3,
	});
	spindle({
		el: scheme.querySelector('.spindle-2'),
	});

	graphBorderAnimate();
	// граифики 1
	graphLineFirstAnimate();
	// // граифики 2
	graphLineAnimate();
	// // граифики 3
	graphOpacityAnimate();
	// // граифики 4
	graphCircleAnimetion();
	// // нижнии линии
	startAnimeProgressLine();

	vibrationSensorAnimate();

	lighting();
};

const init = () => {
	reset();
	create();
};

export default {
	init,
	reset,
	play,
	pause,
};
